<template>
  <div class="time-ctr" ref="container">
    <div class="input time" @click="toggle">
      {{ currentTime.label }}
      <!-- <span class="material-symbols-outlined">expand_more</span> -->
      <img src="/images/expand_more.svg" />
    </div>

    <div class="dropdown" v-show="show">
      <div class="top-btn" @click="showPrev">
        <!-- <span class="material-symbols-outlined">expand_less</span> -->
        <img src="/images/expand_less.svg" />
      </div>

      <div class="wrap" ref="wrap">
        <VueSlickCarousel ref="carousel" v-bind="settings">
          <article
            v-for="(data, idx) in timeOptions"
            :key="idx"
            @click="changeTime(idx)"
            :class="{clicked: currentTime.value === data.value}"
          >
            {{ data.label }}
          </article>
        </VueSlickCarousel>
      </div>

      <div class="down-btn" @click="showNext">
        <!-- <span class="material-symbols-outlined">expand_more</span> -->
        <img src="/images/expand_more.svg" />
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  components: {VueSlickCarousel},

  props: {
    time: null,
  },

  emits: ['time'],

  data: () => ({
    settings: {
      'accessibility': true,
      'dots': false,
      'arrows': false,
      'edgeFriction': 0.35,
      'infinite': false,
      'speed': 500,
      'slidesToShow': 47,
      'slidesToScroll': 1,
      'vertical': true,
      'draggable': true,
      'initialSlide': 0,
      'swipeToSlide': true,
      'touchMove': true,
    },
    currentTime: {
      label: '9:00 AM',
      value: '09:00',
      idx: 18,
    },
    show: false,
    timeOptions: [
      {
        label: 'Midnight',
        value: '00:00',
      },
      {
        label: '12:30 AM',
        value: '00:30',
      },
      {
        label: '1:00 AM',
        value: '01:00',
      },
      {
        label: '1:30 AM',
        value: '01:30',
      },
      {
        label: '2:00 AM',
        value: '02:00',
      },
      {
        label: '2:30 AM',
        value: '02:30',
      },
      {
        label: '3:00 AM',
        value: '03:00',
      },
      {
        label: '3:30 AM',
        value: '03:30',
      },
      {
        label: '4:00 AM',
        value: '04:00',
      },
      {
        label: '4:30 AM',
        value: '04:30',
      },
      {
        label: '5:00 AM',
        value: '05:00',
      },
      {
        label: '5:30 AM',
        value: '05:30',
      },
      {
        label: '6:00 AM',
        value: '06:00',
      },
      {
        label: '6:30 AM',
        value: '06:30',
      },
      {
        label: '7:00 AM',
        value: '07:00',
      },
      {
        label: '7:30 AM',
        value: '07:30',
      },
      {
        label: '8:00 AM',
        value: '08:00',
      },
      {
        label: '8:30 AM',
        value: '08:30',
      },
      {
        label: '9:00 AM',
        value: '09:00',
      },
      {
        label: '9:30 AM',
        value: '09:30',
      },
      {
        label: '10:00 AM',
        value: '10:00',
      },
      {
        label: '10:30 AM',
        value: '10:30',
      },
      {
        label: '11:00 AM',
        value: '11:00',
      },
      {
        label: '11:30 AM',
        value: '11:30',
      },
      {
        label: '12:00 PM',
        value: '12:00',
      },
      {
        label: '12:30 PM',
        value: '12:30',
      },
      {
        label: '1:00 PM',
        value: '13:00',
      },
      {
        label: '1:30 PM',
        value: '13:30',
      },
      {
        label: '2:00 PM',
        value: '14:00',
      },
      {
        label: '2:30 PM',
        value: '14:30',
      },
      {
        label: '3:00 PM',
        value: '15:00',
      },
      {
        label: '3:30 PM',
        value: '15:30',
      },
      {
        label: '4:00 PM',
        value: '16:00',
      },
      {
        label: '4:30 PM',
        value: '16:30',
      },
      {
        label: '5:00 PM',
        value: '17:00',
      },
      {
        label: '5:30 PM',
        value: '17:30',
      },
      {
        label: '6:00 PM',
        value: '18:00',
      },
      {
        label: '6:30 PM',
        value: '18:30',
      },
      {
        label: '7:00 PM',
        value: '19:00',
      },
      {
        label: '7:30 PM',
        value: '19:30',
      },
      {
        label: '8:00 PM',
        value: '20:00',
      },
      {
        label: '8:30 PM',
        value: '20:30',
      },
      {
        label: '9:00 PM',
        value: '21:00',
      },
      {
        label: '9:30 PM',
        value: '21:30',
      },
      {
        label: '10:00 PM',
        value: '22:00',
      },
      {
        label: '10:30 PM',
        value: '22:30',
      },
      {
        label: '11:00 PM',
        value: '23:00',
      },
      {
        label: '11:30 PM',
        value: '23:30',
      },
    ],
    scrollQueue: [],
  }),

  mounted() {
    if (this.time === null || this.currentTime.value === '09:00') {
      this.$refs.wrap.scrollTo(0, 34 * 19)
    } else {
      this.$refs.wrap.scrollTo(0, 34 * (timeIdx + 1))
    }
    document.body.addEventListener('click', this.isClickOutside)
  },

  destroyed() {
    document.body.removeEventListener('click', this.isClickOutside)
  },

  methods: {
    showNext() {
      this.$refs.wrap.scrollBy(0, 34)
      // this.$refs.carousel?.next()
    },

    showPrev() {
      this.$refs.wrap.scrollBy(0, -34)
      // this.$refs.carousel?.prev()
    },

    changeTime(newTime) {
      this.currentTime = {...this.timeOptions[newTime], idx: newTime}
      this.$emit('time', this.timeOptions[newTime].value)
      this.show = false
    },

    isClickOutside(e) {
      if (e?.target === this.$refs.container || this.$refs.container?.contains(e?.target)) {
        return
      }

      this.show = false
    },

    toggle() {
      this.show = !this.show

      setTimeout(() => {
        this.$refs.wrap.scrollTo(0, 34 * this.currentTime.idx)
      }, 100)
    }
  },

  watch: {
    time: function (newVal) {
      if (newVal !== null && newVal.split(':').length > 1) {
        const timeIdx = this.timeOptions.findIndex((data) => data.value === newVal)
        if (timeIdx >= 0) this.changeTime(timeIdx)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.time-ctr {
  position: relative;
  width: 100% !important;

  @media (min-width: 1281px) {
    width: 102px !important;
  }

  div.input {
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    padding-right: 0 !important;
    border-radius: 0 3px 3px 0 !important;

    width: 100%;
    height: 44px;

    span.material-symbols-outlined {
      margin-left: 0 !important;
      padding: 0 2px 0 0 !important;
      border-radius: 0 3px 3px 0 !important;
    }
  }

  div.dropdown {
    position: absolute;
    top: calc(100% + 3px);
    left: -1px;
    z-index: 9999;
    border-radius: 3px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    width: inherit;

    @media (min-width: 1025px) {
      width: 102px;
    }

    .wrap {
      overflow-y: scroll;
      overflow-x: hidden;
      scroll-snap-type: y mandatory;
      max-height: 276px;
      border-left: solid 1px #E4E7ED;
      border-right: solid 1px #E4E7ED;

      width: inherit;
      background-color: white;

      .slick-slider.slick-vertical .slick-list .slick-track {
        scroll-snap-type: y mandatory;

        .slick-slide {
          scroll-snap-align: start;
        }
      }

      &::-webkit-scrollbar {
        display: none;
      }

      article {
        display: flex !important;
        align-items: center;
        justify-content: center;
        height: 34px;
        font-weight: 400;
        font-size: 12.5px;
        letter-spacing: 0.09px;
        line-height: 1.76;
        border: none;
        margin-bottom: -2px;
        scroll-snap-align: start;

        &:hover, &.clicked {
          background-color: #EC1C24;
          color: white;
        }

        @media (min-width: 769px) {
          justify-content: flex-start;
          padding-left: 11px;
        }
      }
    }

    .top-btn {
      height: 18px;
      border-radius: 3px 3px 0 0;
      border-top: solid 1px #E4E7ED;
      border-left: solid 1px #E4E7ED;
      border-right: solid 1px #E4E7ED;
    }

    .down-btn {
      height: 26px;
      border-radius: 0 0 3px 3px;
      padding-top: 3px;
      border-bottom: solid 1px #E4E7ED;
      border-left: solid 1px #E4E7ED;
      border-right: solid 1px #E4E7ED;
    }

    .top-btn,
    .down-btn {
      display: flex;
      justify-content: center;

      cursor: pointer;
      background-color: white;
      width: inherit;
      -webkit-user-select: none; /* Safari */
      -ms-user-select: none; /* IE 10 and IE 11 */
      user-select: none; /* Standard syntax */
      padding-left: 1px;

      .material-symbols-outlined {
        background-color: transparent;
        width: 100%;
        font-size: 21px;
        font-weight: 100;
        text-align: center;
        color: #3B3E40;
        justify-content: center;
        height: auto !important;
        margin-left: 0 !important;
        padding: 0 !important;
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10 and IE 11 */
        user-select: none; /* Standard syntax */
      }
    }
  }
}
</style>
